import { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { alertActions } from '../../_actions/alert.actions';
import animation_shield from '../../assets/01_Traverse_Paper_Shield.json';

import './Registration.css';
import { Button, Checkbox, IconButton, InputAdornment, TextField } from '@material-ui/core';
import { ArrowForward, Visibility, VisibilityOff } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import Lottie from 'lottie-react';
import queryString from 'query-string';
import { User } from '../../proto/user';

enum FormField {
    FIRST_NAME = 'First Name',
    LAST_NAME = 'Last Name',
    PHONE_NUMBER = 'Phone Number',
    EMAIL = 'Email',
    PASSWORD = 'Password',
    CONFIRM_PASSWORD = 'Password Confirmation'
}

type Props = {
    displaySuccessAlert: any,
    displayErrorAlert: any
}

const Registration = (props: any) => {
    const history = useHistory();

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [referrerCode, setReferrerCode] = useState<string | undefined>(undefined);
    // const [tosAccepted, setTosAccepted] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [submitted, setSubmitted] = useState(false);

    let [errors, setErrors] = useState<any>({});


    useEffect(() => {
        const queryParams = queryString.parse(window.location.search);

        if (queryParams.referrer) {
            setReferrerCode(queryParams.referrer as string);
        }
    }, [])

    const updateForm = (name: string, value: any) => {
        switch (name) {
            case FormField.FIRST_NAME:
                setFirstName(value);
                break;
            case FormField.LAST_NAME:
                setLastName(value);
                break;
            case FormField.PHONE_NUMBER:
                setPhoneNumber(value);
                break;
            case FormField.EMAIL:
                setEmail(value);
                break;
            case FormField.PASSWORD:
                setPassword(value);
                break;
            case FormField.CONFIRM_PASSWORD:
                setConfirmPassword(value);
                break;
        }

        if (errors[name]) {
            validateField(errors, name, value);
        }
    }

    const validateForm = () => {
        let formErrors = JSON.parse(JSON.stringify(errors));

        formErrors = validateField(formErrors, FormField.FIRST_NAME, firstName);
        formErrors = validateField(formErrors, FormField.LAST_NAME, lastName);
        formErrors = validateField(formErrors, FormField.PHONE_NUMBER, phoneNumber);
        formErrors = validateField(formErrors, FormField.EMAIL, email);
        formErrors = validateField(formErrors, FormField.PASSWORD, password);
        formErrors = validateField(formErrors, FormField.CONFIRM_PASSWORD, confirmPassword);

        setErrors(formErrors);

        return formErrors;
    }

    const validateField = (formErrors: any, name: string, value: any) => {
        const errorMessages = {
            required: `${name} is required`,
            malformed: `Invalid ${name}`,
            passwordDoesNotMatch: `Passwords do not match`,
            passwordLength: `Password must be at least 8 characters`
        }

        const errorsCopy = JSON.parse(JSON.stringify(formErrors));

        switch (name) {
            case FormField.FIRST_NAME:
                if (!value || value === '') {
                    errorsCopy[FormField.FIRST_NAME] = errorMessages.required
                } else {
                    delete errorsCopy[FormField.FIRST_NAME];
                }
                break;
            case FormField.LAST_NAME:
                if (!value || value === '') {
                    errorsCopy[FormField.LAST_NAME] = errorMessages.required
                } else {
                    delete errorsCopy[FormField.LAST_NAME];
                }
                break;
            case FormField.PHONE_NUMBER:
                if (!value || value === '') {
                    errorsCopy[FormField.PHONE_NUMBER] = errorMessages.required
                } else if (!value.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)) {
                    errorsCopy[FormField.PHONE_NUMBER] = errorMessages.malformed
                }
                else {
                    delete errorsCopy[FormField.PHONE_NUMBER];
                }
                break;
            case FormField.EMAIL:
                if (!value || value === '') {
                    errorsCopy[FormField.EMAIL] = errorMessages.required
                } else if (!value.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                    errorsCopy[FormField.EMAIL] = errorMessages.malformed
                }
                else {
                    delete errorsCopy[FormField.EMAIL];
                }
                break;
            case FormField.PASSWORD:
                if (!value || value === '') {
                    errorsCopy[FormField.PASSWORD] = errorMessages.required
                } else if (value.length < 8) {
                    errorsCopy[FormField.PASSWORD] = errorMessages.passwordLength

                } else {
                    delete errorsCopy[FormField.PASSWORD];
                }
                break;
            case FormField.CONFIRM_PASSWORD:
                if (!value || value === '') {
                    errorsCopy[FormField.CONFIRM_PASSWORD] = errorMessages.required
                } else if (value !== password) {
                    errorsCopy[FormField.CONFIRM_PASSWORD] = errorMessages.passwordDoesNotMatch
                } else {
                    delete errorsCopy[FormField.CONFIRM_PASSWORD];
                }
                break;
        }

        setErrors(errorsCopy);
        return errorsCopy;
    }

    const saveForm = () => {
        const formErrors = validateForm();

        if (Object.keys(formErrors).length > 0) {
            return;
        }

        setSubmitted(true);

        // if (!tosAccepted) {
        //     return;
        // }

        const user: User = {
            firstName,
            lastName,
            phoneNumber,
            email,
            emailVerified: false,
            id: 0,
            created: new Date(),
            updated: new Date(),
            deleted: new Date(0),
            roles: [],
            completedTutorial: false,
            presignedCDCCredentialURL: '',
            totpEnabled: false,
            hasStripeCustomerRecord: false,
            account: undefined
        };

        history.push('/register', { user, password, referrerCode });
    }

    return <Fragment>
        <div className="AppContent">
            <div className="FormContainer">
                <div className="FormImage">
                    <Lottie style={{ height: 224 }} loop={false} animationData={animation_shield} />
                </div>
                <div className="FormContent">
                    <div className="FormTitle">
                        Create your Traverse Account
                    </div>
                    <div className="FormContent">
                        <div className="FormRow">
                            <TextField
                                className="FormInputHalf"
                                required
                                value={firstName}
                                onChange={(e) => { updateForm(FormField.FIRST_NAME, e.target.value) }}
                                onBlur={(e) => { validateField(errors, FormField.FIRST_NAME, e.target.value) }}
                                name={FormField.FIRST_NAME}
                                label="First Name"
                                variant="outlined"
                                size="small"
                                error={!!errors[FormField.FIRST_NAME]}
                                helperText={errors[FormField.FIRST_NAME] ? errors[FormField.FIRST_NAME] : ''}
                            />
                            <TextField
                                className="FormInputHalf"
                                required
                                value={lastName}
                                onChange={(e) => { updateForm(FormField.LAST_NAME, e.target.value) }}
                                onBlur={(e) => { validateField(errors, FormField.LAST_NAME, e.target.value) }}
                                name={FormField.LAST_NAME}
                                label="Last Name"
                                variant="outlined"
                                size="small"
                                error={!!errors[FormField.LAST_NAME]}
                                helperText={errors[FormField.LAST_NAME] ? errors[FormField.LAST_NAME] : ''}
                            />
                        </div>
                        <div className="FormRow">
                            <TextField
                                className="FormInputHalf"
                                required
                                value={phoneNumber}
                                onChange={(e) => { updateForm(FormField.PHONE_NUMBER, e.target.value) }}
                                onBlur={(e) => { validateField(errors, FormField.PHONE_NUMBER, e.target.value) }}
                                name={FormField.PHONE_NUMBER}
                                label="Phone Number"
                                variant="outlined"
                                size="small"
                                error={!!errors[FormField.PHONE_NUMBER]}
                                helperText={errors[FormField.PHONE_NUMBER] ? errors[FormField.PHONE_NUMBER] : ''}
                            />
                            <TextField
                                className="FormInputHalf"
                                required
                                value={email}
                                onChange={(e) => { updateForm(FormField.EMAIL, e.target.value) }}
                                onBlur={(e) => { validateField(errors, FormField.EMAIL, e.target.value) }}
                                name={FormField.EMAIL}
                                label="Work Email"
                                variant="outlined"
                                size="small"
                                error={!!errors[FormField.EMAIL]}
                                helperText={errors[FormField.EMAIL] ? errors[FormField.EMAIL] : ''}
                            />
                        </div>

                        <div className="FormRow">
                            <TextField
                                required
                                fullWidth
                                value={password}
                                onChange={(e) => { updateForm(FormField.PASSWORD, e.target.value) }}
                                onBlur={(e) => { validateField(errors, FormField.PASSWORD, e.target.value) }}
                                type={showPassword ? 'text' : 'password'}
                                name={FormField.PASSWORD}
                                label="Password"
                                variant="outlined"
                                size="small"
                                error={!!errors[FormField.PASSWORD]}
                                helperText={errors[FormField.PASSWORD] ? errors[FormField.PASSWORD] : ''}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => { setShowPassword(!showPassword) }}
                                            aria-label="toggle password visibility"
                                            edge="end"
                                            size="small"
                                        >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }}
                            />
                        </div>
                        <div className="FormRow">
                            <TextField
                                required
                                fullWidth
                                value={confirmPassword}
                                onChange={(e) => { updateForm(FormField.CONFIRM_PASSWORD, e.target.value) }}
                                onBlur={(e) => { validateField(errors, FormField.CONFIRM_PASSWORD, e.target.value) }}
                                type={showConfirmPassword ? 'text' : 'password'}
                                name={FormField.CONFIRM_PASSWORD}
                                label="Confirm Password"
                                variant="outlined"
                                size="small"
                                error={!!errors[FormField.CONFIRM_PASSWORD]}
                                helperText={errors[FormField.CONFIRM_PASSWORD] ? errors[FormField.CONFIRM_PASSWORD] : ''}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => { setShowConfirmPassword(!showConfirmPassword) }}
                                            aria-label="toggle password visibility"
                                            edge="end"
                                            size="small"
                                        >
                                            {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }}
                            />
                        </div>

                        {referrerCode && <div className="FormRow">
                            <TextField fullWidth disabled value={referrerCode} label="Referral Code" variant="outlined" size="small" />
                        </div>}


                        {/* <div className="FormRow FormPrompt">
                            <Checkbox
                                color="primary"
                                style={(!tosAccepted && submitted) ? {color: '#f44336'} : {}}
                                value={tosAccepted}
                                onChange={(e) => { setTosAccepted(e.target.checked) }} />
                            I agree to the Traverse <span className="FormLink">Privacy Policy</span> and <span className="FormLink">Terms of Service</span>
                        </div> */}

                        {/* {(!tosAccepted && submitted)&&<div className="FormError">You must accept the privacy policy and terms of service</div>} */}
                    </div>

                    <div className="FormFooter">
                        <Button
                            onClick={saveForm}
                            color="primary"
                            variant="contained">Continue <ArrowForward /></Button>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
}

const mapState = (state: any) => { return {} }

const actionCreators = {
    displayErrorAlert: alertActions.error,
    displaySuccessAlert: alertActions.success
};

const connectedApp = connect(mapState, actionCreators)(Registration);

export { connectedApp as Registration };